"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeIntervalPicker = void 0;
const TimeInterval_1 = __importStar(require("@opsbase/lib-time/TimeInterval"));
const MenuItem_1 = __importDefault(require("@opsbase/web-ui/MenuItem/MenuItem"));
const Select_1 = __importDefault(require("@opsbase/web-ui/Select"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importDefault(require("react"));
const makePicker_1 = __importDefault(require("../helpers/makePicker"));
exports.TimeIntervalPicker = (0, makePicker_1.default)((props) => {
    return (react_1.default.createElement(Select_1.default, Object.assign({}, props), Object.values(TimeInterval_1.default).map(v => (react_1.default.createElement(MenuItem_1.default, { key: v, value: v },
        react_1.default.createElement(Text_1.default, null, (0, TimeInterval_1.timeIntervalLabel)(v)))))));
});
exports.default = exports.TimeIntervalPicker;
